<template>
  <div class="pageShow" v-if="tabShow" :class="{ 'pg2': pageBg }">
    <div class="title-heading" style="margin-left: 35px;" v-if="this.pageIndex == 4">
      <p>
        <i style="position: relative; top: 5px;margin-right: 5px;">
          <img src="@/assets/titleBlock/heading1.png" alt="">
        </i>
        {{ titlePage }}
        <i style="position: relative; top: 5px;margin-left: 5px;">
          <img src="@/assets/titleBlock/heading2.png" alt="">
        </i>
      </p>
    </div>
    <div style="display:block;">
      <div v-if="!this.pageIndex && !shouldHideThumbnail" class="title-img">
        <TitleBlockImg></TitleBlockImg>
      </div>
      <li v-for="(item, index) in columnInfo" :key="index">
        <div class="heading" v-if="item.uiType == 8">
          <p>
            <i style="position: relative; top: 5px;margin-right: 5px;">
              <img src="@/assets/titleBlock/heading1.png" alt="">
            </i>
            {{ item.val }}
            <i style="position: relative; top: 5px;margin-left: 5px;">
              <img src="@/assets/titleBlock/heading2.png" alt="">
            </i>
          </p>
        </div>
        <div v-else>
          <div v-if="item.uiType == 2" style="width: 100%;  margin: 5px 0; display: flex; align-items: center;">
            <div style="flex-shrink: 0;flex-basis: 240px;" class="list-title">
              <el-tooltip v-if="item.descriptions.length !== 0" effect="dark" placement="top-start">
                <i class="el-icon-info"></i>
                <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
              </el-tooltip>
              <span v-if="item.required" style="color: red;">{{ "*" }}</span>
              {{ item.name }}<span style=" margin: 0 3px;">:</span>
            </div>
            <div v-if="item.id !== 1002130" class="isMat" :class="{ 'nodata': !item.val, }">
              <!-- <textarea :rows="4" placeholder="请输入内容"> {{ item.val || noData }} </textarea> -->
              <span v-if="!item.val"> {{ noData }} </span>
              <template v-else>
                <div v-html="setVal(item)"> </div>
              </template>
            </div>
            <div v-else>
              <QRCode :data="item" />
            </div>

          </div>

          <div class="table-list" v-else
            :class="[baseClass, { 'active-wide': isWideMode && baseClass === 'active', 'active2-wide': isWideMode && baseClass === 'active2' }]">
            <div style="display: flex; margin: 5px 0; align-items: baseline">
              <!-- :content="item.descriptions" -->
              <div style="flex-shrink: 0;flex-basis: 240px;" class="list-title">
                <el-tooltip v-if="item.descriptions.length !== 0" effect="dark" placement="top-start">
                  <i class="el-icon-info"></i>
                  <div slot="content" style="width: 320px;" v-html="item.descriptions"></div>
                </el-tooltip>
                <span v-if="item.required" style="color: red;">{{ "*" }}</span>
                {{ item.name }}<span style=" margin: 0 3px;">:</span>
              </div>
              <div style="flex: 1;">

                <div v-if="[3, 4].includes(item.uiType)">
                  <span v-if="!item.val || !item.val.length" class="nodata"> {{ noData }}</span>
                  <span v-else>
                    <span v-for="(val, index) in item.val" :title="val.title" style="font-size: 14px;"
                      :class="{ 'manufact': val.link }" :key="index" @click="listClick(val)">
                      {{ val.title }}<span v-show="item.uiType === 4">；</span>
                    </span>
                  </span>
                </div>
                <div v-else-if="item.uiType == 2" :title="item.val" class="isMat" :class="{ 'nodata': !item.val, }">
                  {{ item.val || noData }}
                </div>

                <div v-else :title="item.val" style="font-size: 14px;" :class="{ 'nodata': !item.val, }">
                  {{ item.val || noData }}
                </div>

              </div>
            </div>
          </div>
        </div>

      </li>
      <div v-show="!this.pageIndex && deliverList.length" style="width:100%;margin-bottom: 25px;">
        <div style="width:96%">
          <el-divider></el-divider>
        </div>

        <div class="title-heading" style="margin-left: 35px;">
          <p>
            <span style="font-size:16px;font-weight: 600;margin:0 8px 0 45px;">归属项目列表</span>
            <i style="position: relative; top: 5px;margin-left: 5px;">
              <img src="@/assets/titleBlock/heading2.png" alt="">
            </i>
          </p>
        </div>
        <li v-for="item in deliverList" :key="item.id">
          <div style="line-height:24px">
            <div class="aa">
              <span class="list-key" :title="item.type">{{ '归属' + item.type }}</span>
            </div>
            <div class="middle">
              :
            </div>
            <div class="bb">
              <span class='manufact' style="margin-right:60px" :title="item.name" @click="cellClick(item)">{{ item.name
              }}</span>
              <span v-for="i in item.children" :key="i.id" style="margin:0 5px">
                {{ '关联' + i.type + ": " }}
                <span class="manufact" @click="cellClick(i)" :title="i.name">
                  {{ i.name }}
                </span>
              </span>
            </div>
          </div>
        </li>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import TitleBlockImg from "./titleBlockImg.vue";
import { densityList } from '@/utils/density.js'
import QRCode from "./QR_Code.vue";
export default {
  data() {
    return {
      tabShow: true,
      pageInfo: {},
      columnInfo: [],
      column: [],
      ColPage: false,
      titlePage: '',
      pageBg: false,
      searchMf: '',
      pageOrder: [this.$t("message.title.pageOne"), this.$t("message.title.pageTwo"), this.$t("message.title.pageThree")],

      noData: this.$t("message.tips.noData"),

      pageData: {},
      input_width: {
        width: "50%",
      },
      deliverList: []

    }
  },
  components: {
    TitleBlockImg, QRCode
  },
  props: ["page", 'pageIndex', 'reset'],
  methods: {

    setVal(item) {
      const p = item.val.replaceAll('\n', '</br>').replaceAll(' ', '&nbsp;');     // const p = item.val.replaceAll(' ', '&nbsp;');
      return `<p style ='margin:0;'> ${p} </p>`
    },

    listClick(item) {
      console.log(item);
      if (!item.link) {
        return
      }

      axios.get('pmdm/admin/list/getObjectInfoByListId?listEntryId=' + item.id).then(res => {
        console.log(res);
        const obj = { ...res.data.object, title: item.title };
        this.getLink(obj);
        this.$store.commit('setPageRefresh');
      })

      // if (!item.hasOwnProperty('objectId')) {
      //   this.manuClick()
      // } else {
      //   this.getLink(item.objectId)
      //   this.$store.commit('setPageRefresh');
      // }

    },
    getColumn() {

      this.tabShow = !!this.page.column.ids.length;
      if (!this.tabShow) {
        this.columnInfo = []
        return
      };

      const getVal = (obj) => {
        try {
          const a = JSON.parse(obj);
          return a;
        } catch (error) {
          return obj
        }
      }
      // console.log(this.page.column);
      let arr = this.getNewData(this.page.column);
      // console.log(arr);
      const val = this.page.val.cells;
      console.log(val);

      this.columnInfo = arr.map((i, e) => {

        // console.log(val);
        i.val = val[e].val

        if (i.uiType == 3 && val[e].val) {

          i.val = [{ title: val[e].val, id: val[e].id, link: i.listType === 3 }]
        }
        if (i.uiType == 4 && val[e].val) {

          const idList = val[e].ids.split(';');
          const valList = val[e].val.split(';');
          i.val = idList.map((j, x) => ({ id: j, title: valList[x], link: i.listType === 3 }))
        }
        //   const cc = getVal(val[e].val)
        //   if (typeof cc === 'string') {
        //     i.val = [{title:cc}]
        //   } else {
        //     i.val = cc
        //   }
        // } else {
        //   i.val = [{'title': val[e].val}]
        // }
        //   if (i.uiType == 6) {
        //     i.val = ''
        //     // i.val = JSON.stringify(val[e].date) =='{}' ? '':val[e].date;
        //   }
        return i;
      })

      console.log(this.columnInfo);
      // let systemName = window.sessionStorage.getItem("systemName");
      // if (systemName.indexOf("帝京") != -1 && this.pageIndex == 2) {
      //   this.countMass();
      // }
    },
    manuClick() {
      // //// // console.log(this.columnInfo);
      let val = this.columnInfo.find(i => i.id == 1012002).val[0].val;
      axios.get("/pmdm/manufacturers/getManufacturers?name=" + val)
        .then(res => {
          let obj = res.data.object.manufacturers[0];
          obj.title = val;
          this.getLink(obj)

        })
    },
    cellClick(e) {
      // console.log(e);
      this.getLink(e)


    },
    getObjectRalationship() {
      let obj = {
        effObjid: this.$store.state.objectId.id,
        classId: this.$store.state.objectId.classId,
        subClassId: this.$store.state.objectId.subClassId,
      }
      axios.get('/pmdm/relationship/getObjectListByRelationShip', {
        params: obj
      }).then(
        res => {
          let arr = res.data.object.table;
          this.deliverList = Object.keys(arr).map(key => {
            const i = arr[key];
            let n = {
              id: i[0].objId,
              classId: i[0].classId,
              subClassId: i[0].subClassId,
              name: i[0].name,
              type: i[0].subClassName,
              children: []
            };
            i.map(j => {
              j.childObjId && n.children.push({
                name: j.childName,
                type: j.childSubClassName,
                id: j.childObjId,
                classId: j.childClassId,
                subClassId: j.childSubClassId
              })
            })
            return n;
          })
          // console.log(this.deliverList);
        }
      )
    },
    countMass() {
      const item = densityList.find(i => i.subClassId == this.$store.state.objectId.subClassId);
      if (!item?.densityParams) {
        return;
      }
      const [x, y] = item.densityParams.map(i => {
        const n = this.columnInfo.find(j => j.id == i);
        // // console.log(n);
        return n.val.id
        // return this.pageData[n]
      })
      let n = 0;

      if (item.densityParams.length < 2) {
        n = item.list.find(i => i.aId == x || !i.aId).value;
      } else {
        const m = item.list.find(i => i.aId == x || !i.aId);
        if (!m.hasOwnProperty('bId')) {
          n = m.value;
        } else {
          n = item.list.find(i => i.aId == x && i.bId == y || !i.aId).value;
        }
      }
      // console.log(item.list,x,y,n);
      const [a, b, c] = item.shapeParams.map(i => {
        const n = this.columnInfo.find(j => j.id == i);
        return n.val.val
      })

      const obj = this.columnInfo.find(i => i.id == item.massId);
      // console.log(a,b,c,item.formula(a,b,c),n,(item.formula(a,b,c) * n));
      obj.val.val = (item.formula(a, b, c) * n).toFixed(2);
    }


  },
  mounted() {
    this.titlePage = this.pageOrder[this.pageIndex];
    this.ColPage = !!this.pageIndex;
    this.pageBg = !!(this.pageIndex == 1);

  },
  created() {
    // //// // console.log(this.pageId);
    this.getColumn();
    !this.pageIndex && this.getObjectRalationship()
  },
  computed: {
    subClassId() {
      return this.$store.state.objectId.subClassId;
    },
    shouldHideThumbnail() {
      return this.subClassId === 9010101;
    },
    isWideMode() {
      return this.subClassId === 9010101;
    },
    baseClass() {
      return this.ColPage ? 'active' : 'active2';
    }
  },
  watch: {
    reset() {
      this.getColumn();
    },
    page: {
      handler(e) {
        //// // console.log(e);
        if (e) {
          this.getColumn();
        }
      },
      // deep: true,
      // immediate: false,
    }
  }
}
</script>


<style>
.tips ::v-deep .el-tooltip__popper {
  width: 200px !important;
}

li {
  list-style: none;
}

.moneyUi .el-input-group__append {
  width: 30% !important;
}
</style>

<style scoped>
.title-img {
  height: 240px;
  width: 322px;
  background-color: #fbfdff;
  float: right;
  margin-right: 18%
}

.pageShow {
  width: 100%;
  margin: 10px 0 0 0;
  padding: 15px 0 20px 15px;
  position: relative;
  display: block;
  overflow: hidden;
}

.list-title {
  text-align: right;
  font-size: 14px;
  min-width: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.active {
  width: 33%;
  float: left;
  transition: all 0.3s;
}

.active2 {
  width: 33%;
  display: block;
  transition: all 0.3s;
}

.active-wide {
  width: 90%;
  float: left;
}

.active2-wide {
  width: 90%;
  display: block;
}

.manufact {
  color: #4b91ff;
  cursor: pointer;

}

.nodata {
  pointer-events: none;
  user-select: none;
  color: #c0c4cc;
  font-size: 14px;
}

.manufact:hover {
  text-decoration: underline;

}

.list-item {
  /* line-height: 24px; */
  overflow: hidden;
  margin-top: 3px;
}

.aa {
  /* background: #4b91ff; */
  font-size: 14px;
  width: 20%;
  float: left;
  text-align: right;
}

.middle {
  float: left;
  margin: 0 6px;
  /* line-height: 20px; */
}

.bb {
  font-size: 14px;
  width: 70%;
  float: left;
  /* background: violet; */
}

.items li {
  list-style: none;
}

.item-textarea {}

.pg2 {
  padding: 15px 15px 20px 15px;
  overflow: hidden;
  background: #f3f7fa;
  background-image: url(~@/assets/titleBlock/page2.png);
  background-repeat: no-repeat;
  background-position: bottom right;
}

.heading {
  width: 100%;
  float: left;
  margin: 0px 0 8px 55px;
}

.heading-edit {
  width: 100% !important;
  margin: 0 0 8px 40px;
}

.heading p {
  font-size: 16px;
  margin: 0;
}

.title-heading {
  width: 100%;
  float: left;
  margin: 0 0 10px 0px;
}

.title-heading p {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

.page1 {
  width: 50%;
  overflow: hidden;
}

.page2 {
  width: 50%;
  float: left;
}

.page3 {
  width: 50%;
  float: left;
}

ul {
  margin: 0;
}

.line01 {
  border-bottom: 1px solid #cecece;
  padding: 10px 0;
}


.list-val:empty::before {
  /* content: '\6682\65e0'; */
  content: attr(data-attr);
  color: #C0C4CC;
}

.table-list {
  margin-top: 3px;
  overflow: hidden;
}

.table-list-rela {
  /* height: 24px; */
  overflow: hidden;
  margin-top: 3px;
}


.table-list li {
  overflow: hidden;
}

.table-list .list-key {
  /* text-align: right; */
  font-size: 14px;
  /* height: 20px; */
  /* float: left; */
}

.table-list .list-val-rela {
  display: inline-block;
  /* width: 52%; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* line-height: 18px; */
  font-size: 14px;
  position: relative;
  /* top: 3px; */
}

.isMat {
  display: block;
  width: 100%;
  /* font-size: 14px; */
  padding-right: 8%;
  /* width: 52%; */
  /* float: left; */
  line-height: 18px;
  font-size: 14px;
  min-height: 21px;
  word-break: break-all;
  /* display: -webkit-box;
  -webkit-line-clamp: 3;
  overflow: hidden;

  word-break: break-all;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis; */
}

::v-deep .isMat .el-textarea__inner {
  border: none;
}
</style>
